var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedTik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12186FFD-90D0-405F-9CE4-D08093E33246") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Patients",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-6/7/8-\\u2013-39-Copy-78",
    transform: "translate(-170.000000, -235.000000)",
    fill: "#D81D5D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "E",
    transform: "translate(170.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9980558,36 C26.5849984,36.0005746 33.9765259,29.9351994 35.6521919,21.5132843 C37.3278578,13.0913692 32.8209543,4.65859227 24.8877746,1.37219857 C16.9545948,-1.91419514 7.80469408,0.861123201 3.03388967,8.00084834 C-1.73691473,15.1405735 -0.799854731,24.6561438 5.2719906,30.7281088 C8.64716184,34.1033466 13.2248114,36 17.9980558,36 L17.9980558,36 Z M17.9980558,3.48741231 C24.9224994,3.48791192 30.8823221,8.37973725 32.2327599,15.1712644 C33.5831977,21.9627916 29.9481384,28.7625031 23.5506235,31.4119963 C17.1531085,34.0614895 9.77491847,31.8228505 5.92822783,26.0651317 C2.0815372,20.307413 2.83769304,12.6342047 7.73426391,7.73810139 C10.4564659,5.01615932 14.1484772,3.48741231 17.9980558,3.48741231 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "16.2 17.1 19.8 17.1 19.8 27.9 16.2 27.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "16.2 9 19.8 9 19.8 12.6 16.2 12.6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTik);
export default __webpack_public_path__ + "static/media/redTik.b673c0a6dd058a05ebeb9eb4b09ea086.svg";
export { ForwardRef as ReactComponent };